// extracted by mini-css-extract-plugin
module.exports = {"SolarPower":"SolarPower-V2_SolarPower__3dXzU"};